import { LocationProps } from '@components/Location/location.types'
import Desktop from '@components/Location/Desktop'
import Mobile from '@components/Location/Mobile'

const Location = (props: LocationProps) => {
  return (
    <>
      <Desktop {...props} />
      <Mobile {...props} />
    </>
  )
}

export default Location
